<template>
  <div class="change-data-wrapper">
    <el-table :data="data" border style="width: 100%" header-row-class-name="headerTable"
      :cell-style="{ padding: '8px 0' }">
      <el-table-column prop="name" label="数据项" align="center" width="150">
        <template slot-scope="scope">
          <span class="data-item-name">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="oldValue" label="变更前" align="center">
        <template slot-scope="scope">
          <div class="change-value-cell">
            <span v-if="scope.row.oldValue" :class="{'value-changed': String(scope.row.oldValue) !== String(scope.row.newValue)}">
              {{ scope.row.oldValue }}
            </span>
            <el-tag v-else type="info" size="small">NA</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="newValue" label="变更后" align="center">
        <template slot-scope="scope">
          <div class="change-value-cell">
            <span v-if="scope.row.newValue" :class="{'value-changed': String(scope.row.oldValue) !== String(scope.row.newValue)}">
              {{ scope.row.newValue }}
            </span>
            <el-tag v-else type="info" size="small">NA</el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  name: "ProtectiveFluidChangeData",
  props: {
    oldData: {
      default: () => ({})
    },
    newData: {
      default: () => ({})
    },
  },
  data() {
    return {
      data: [],
    }
  },
  mounted() {
    this.getProtectiveFluidData()
  },
  methods: {
    hasProtectiveFluidInfo(data) {
      return data && data.protectiveFluidInfo && data.protectiveFluidInfo.protectiveFluidMethod
    },
    getProtectiveFluidData() {
      try {
        const oldInfo = this.oldData?.protectiveFluidInfo || {}
        const newInfo = this.newData?.protectiveFluidInfo || {}

        // 如果变更前后都没有解离样品投递方式信息，则不展示
        if (!this.hasProtectiveFluidInfo(this.oldData) && !this.hasProtectiveFluidInfo(this.newData)) {
          return
        }

        const oldMethod = oldInfo.protectiveFluidMethod || ''
        const newMethod = newInfo.protectiveFluidMethod || ''

        const tableData = []

        // 投递方式
        tableData.push({
          name: '解离样品投递方式',
          oldValue: oldMethod ? (oldMethod === 'DOOR' ? '上门' : '邮寄') : '',
          newValue: newMethod ? (newMethod === 'DOOR' ? '上门' : '邮寄') : ''
        })

        // 上门信息
        const oldDoorInfo = oldInfo.doorInfo || {}
        const newDoorInfo = newInfo.doorInfo || {}

        // 上门时间
        if (oldMethod === 'DOOR' || newMethod === 'DOOR') {
          tableData.push({
            name: '上门时间',
            oldValue: oldMethod === 'DOOR' ? (oldDoorInfo.doorTime || '') : '',
            newValue: newMethod === 'DOOR' ? (newDoorInfo.doorTime || '') : ''
          })
          // 上门费用
          tableData.push({
            name: '上门费用',
            oldValue: oldMethod === 'DOOR' ? (oldDoorInfo.doorFee || '') : '',
            newValue: newMethod === 'DOOR' ? (newDoorInfo.doorFee || '') : ''
          })
          // 联系方式
          tableData.push({
            name: '联系方式',
            oldValue: oldMethod === 'DOOR' ? (oldDoorInfo.phone || '') : '',
            newValue: newMethod === 'DOOR' ? (newDoorInfo.phone || '') : ''
          })
          // 上门地址
          tableData.push({
            name: '上门地址',
            oldValue: oldMethod === 'DOOR' ? (oldDoorInfo.address || '') : '',
            newValue: newMethod === 'DOOR' ? (newDoorInfo.address || '') : ''
          })
        }

        // 邮寄信息
        const oldMailInfo = oldInfo.materialMailInfo || {}
        const newMailInfo = newInfo.materialMailInfo || {}

        // 邮寄时间
        if (oldMethod === 'MAIL' || newMethod === 'MAIL') {
          tableData.push({
            name: '邮寄时间',
            oldValue: oldMethod === 'MAIL' ? (oldMailInfo.mailTime || '') : '',
            newValue: newMethod === 'MAIL' ? (newMailInfo.mailTime || '') : ''
          })
          // 收件人
          tableData.push({
            name: '收件人',
            oldValue: oldMethod === 'MAIL' ? (oldMailInfo.recipient || '') : '',
            newValue: newMethod === 'MAIL' ? (newMailInfo.recipient || '') : ''
          })
          // 收件人电话
          tableData.push({
            name: '收件人电话',
            oldValue: oldMethod === 'MAIL' ? (oldMailInfo.phone || '') : '',
            newValue: newMethod === 'MAIL' ? (newMailInfo.phone || '') : ''
          })
          // 收件地址
          tableData.push({
            name: '收件地址',
            oldValue: oldMethod === 'MAIL' ? (oldMailInfo.address || '') : '',
            newValue: newMethod === 'MAIL' ? (newMailInfo.address || '') : ''
          })
        }

        this.data = tableData
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.change-data-wrapper {
  ::v-deep .headerTable th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #303133;
  }
}

.data-item-name {
  font-weight: 500;
  color: #606266;
}

.change-value-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 24px;
}

.value-changed {
  color: #f56c6c;
  font-weight: 500;
}
</style>
